import { VStack, Box, UnorderedList, ListItem, Flex, Alert, AlertIcon, AlertDescription, Text } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskDescription from '../components/TaskDescription'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'

export default function N25_09_29() {
  return (
    <NoteContainer date={'29/09/2025'} version="20.5.0">
      <VStack w="full">
        <ModuleContainer moduleName="ATTENDANCES">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção na listagem dos tipos de alertas</TaskTitle>
                <TaskBreadcrumb>Atendimento presencial/ Perfil do atendimento</TaskBreadcrumb>
                <TaskDescription>
                  Corrigido erro de não listar os tipos de alertas no lançamento de alertas
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="SERVICES_LETTER">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Flex flexDir="column" gap={2}>
                <Box>
                  <TaskTitle important={true}>Solicitação anônima + Ajustes na lógica de solicitar serviço</TaskTitle>
                  <TaskBreadcrumb>Serviços/ Perfil do serviço/ Informações de solicitação</TaskBreadcrumb>
                  <TaskDescription>
                    Possibilidade de receber solicitações de forma anônima, além da reestruturação da lógica de
                    solicitação, deixando mais fácil a parametrização e controle por parte do usuário.
                  </TaskDescription>
                </Box>

                <Alert status="info" alignItems={'start'} rounded="md">
                  <AlertIcon />
                  <AlertDescription>
                    <Box mb={4}>
                      <Text fontSize={'sm'} color="gray.600">
                        Teremos três campos de informação geral sobre a solicitação do serviço. Abaixo quais são esses
                        campos e uma descrição sobre cada um deles:
                      </Text>
                      <UnorderedList fontSize={'sm'} color="gray.600">
                        <ListItem>
                          <strong>Serviço pode ser solicitado:</strong> determina se o serviço em questão poderá ser
                          solicitado ou não
                        </ListItem>
                        <ListItem>
                          <strong>Serviço regulado:</strong> determina se o serviço em questão se trata de um serviço
                          regulado ou não. Serviços regulados possuem um fluxo próprio utilizando o módulo REGULAÇÃO.
                        </ListItem>
                        <ListItem>
                          <strong>Permitir solicitação anônima:</strong> determina se o serviço em questão poderá ter a
                          opção de ser solicitado de forma anônima, ou seja, não vinculado com o perfil da pessoa.
                        </ListItem>
                      </UnorderedList>
                    </Box>
                    <Box>
                      <Text fontSize={'sm'} color="gray.600">
                        Teremos três níveis de solicitação, onde somente um deles poderá ser selecionado por vez. Abaixo
                        os níveis e uma descrição sobre cada um deles:
                      </Text>
                      <UnorderedList fontSize={'sm'} color="gray.600">
                        <ListItem>
                          <strong>Usuário não autenticado na plataforma:</strong> determina que o serviço em questão
                          poderá ser solicitado mesmo que o solicitando não tenha cadastro na plataforma
                        </ListItem>
                        <ListItem>
                          <strong>Usuário autenticado na plataforma:</strong> determina que o serviço em questão poderá
                          ser solicitado pelo solicitando deste que o mesmo tenha uma conta e esteja logado
                        </ListItem>
                        <ListItem>
                          <strong>Solicitações baseadas no vínculo:</strong> determina se o serviço em questão poderá
                          ser solicitado pelo solicitando deste que o mesmo tenha uma conta, esteja logado e tenha um
                          dos vínculos determinados.
                        </ListItem>
                      </UnorderedList>
                    </Box>
                  </AlertDescription>
                </Alert>
              </Flex>
            </CategoryContainer>
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Reestruturação da página Informações de solicitação</TaskTitle>
                <TaskBreadcrumb>Serviços/ Perfil do serviço/ Informações de solicitação</TaskBreadcrumb>
                <TaskDescription>
                  Ajustes no elementos de formulário da página, organizados por título + descrição, além de auxilio
                  visual para mostrar as opções selecionadas
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção de nomenclatura</TaskTitle>
                <TaskBreadcrumb>Serviços/ Perfil do serviço</TaskBreadcrumb>
                <TaskDescription>
                  Corrigido nomenclatura de item na barra de navegação de &apos;trasmissão&apos; para
                  &apos;transmissão&apos;
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="UNIFIED_LOGIN">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Informações sobre a solicitação</TaskTitle>
                <TaskBreadcrumb>Logun Unificado/ Solicitação de serviço</TaskBreadcrumb>
                <TaskDescription>
                  Caso o usuário não possa solicitar o serviço, agora ele é levado à uma página que apresenta uma
                  informação informando o motivo de não poder solicitar o serviço. O motivo pode ser por alguma
                  pendência da parte do usuário ou uma parametrização incorreta do serviço.
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="CITIZEN_PROFILE">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Consultas externas</TaskTitle>
                <TaskBreadcrumb>Cidadãos/ Perfil do pessoa unificada/ Ações</TaskBreadcrumb>
                <TaskDescription>Adicionadas duas consultas externas na página de ações:</TaskDescription>
                <UnorderedList fontSize={'sm'} color="gray.600">
                  <ListItem>
                    <strong>Consulta Receita Federal:</strong> consulta relalizada na base de dados da Receita Federal,
                    podendo sincronizar os dados para a plataforma Impacto
                  </ListItem>
                  <ListItem>
                    <strong>Consulta SIP-Holerite:</strong> consulta relalizada na base de dados do SIP, podendo gerar
                    PDF do holerite
                  </ListItem>
                </UnorderedList>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="CITIZEN_PORTAL">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Informações sobre a solicitação</TaskTitle>
                <TaskBreadcrumb>Serviços/ Solicitação</TaskBreadcrumb>
                <TaskDescription>
                  Caso o usuário não possa solicitar o serviço, agora é apresentado uma informação abaixo do botão de{' '}
                  <strong>criar solicitação</strong> informando o motivo de não poder solicitar. O motivo pode ser por
                  alguma pendência da parte do usuário ou uma parametrização incorreta do serviço.
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Informação quando o serviço não possui formulário</TaskTitle>
                <TaskBreadcrumb>Serviços/ Solicitação</TaskBreadcrumb>
                <TaskDescription>
                  Caso o serviço não possua formulário de solicitação, agora é informando isso ao usuário. Detalhe que o
                  serviço não possuir formulário não trava a solicitação
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="REGULATION">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Informação quando o serviço não possui formulário de resolução</TaskTitle>
                <TaskBreadcrumb>Painel do regulador</TaskBreadcrumb>
                <TaskDescription>
                  Caso o serviço não possua formulário de aprovação ou recusa, agora é informando isso ao usuário.
                  Detalhe que o serviço não possuir formulário não trava a resolução do mesmo.
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
